export default __webpack_public_path__ + "static/media/manage_contact_icon.c4c7e45d.svg";